// extracted by mini-css-extract-plugin
export default {"heroContainer":"hero_heroContainer__fLXpC","logoContainer":"hero_logoContainer__uEj-T"};